import { batchDownloadZip, processDownload } from '@pba/react-utils';
import { useMutation } from 'query';
import { handleAxiosError } from 'ui';
import type { ApiClientResponseError, ResponseErrorDataObject } from 'common/services';
import { useGetFileMutation } from './useGetFileMutation';

const defaultMutateOnError = (error: ApiClientResponseError<ResponseErrorDataObject>) => {
  handleAxiosError(error, 'Files cannot be downloaded, please try again later.');
};

type FileDownloadParameters = {
  fileName: string;
  url: string;
};

type P = {
  files: FileDownloadParameters[];
  zipFileName?: string;
};

export const useDownloadFilesAsZipMutation = () => {
  const { mutateAsync: getSingleFile } = useGetFileMutation();

  return useMutation({
    defaultMutateOnError,
    async mutationFn({ files, zipFileName = 'attachments.zip' }: P) {
      // TODO: rename in bricks
      return batchDownloadZip({
        // TODO: rename in bricks
        downloadFile: async (url: string) =>
          getSingleFile(
            { url },
            {
              onError() {
                // Empty - override inner error handler
              },
            },
          ),
        files,
        zipFileName,
      });
    },
    onSuccess({ zipBlob, zipFileName }) {
      processDownload({ data: zipBlob, fileName: zipFileName });
    },
  });
};
